// Tokens visuais dos cadastros em etapas (desconto v2, campanha de recuperação).
// Nasceram em resources/discounts/v2/ui/tokens.ts; subiram para cá quando a segunda tela
// precisou deles — um `import '../../discounts/v2/...'` de outro resource é o cheiro de que
// o token é do painel, não daquela tela. O que é só do desconto (TYPE_STYLE, os sx soltos)
// continua lá.
import type { SxProps, Theme } from '@mui/material/styles'

export const C = {
  ink: '#1e293b',
  muted: '#475569',
  quiet: '#64748b',
  violet: '#4433B4',
  violetSoft: '#f5f3ff',
  green: '#79CF62',
  greenHover: '#6cc456',
  greenDark: '#275030',
  line: '#e2e8f0',
  lineSoft: '#eef2f7',
  surface: '#f8fafc',
  inputBorder: '#7c8595',
  radioBorder: '#cbd5e1',
  red: '#c62828',
  chipBg: '#eef2ff',
  chipBorder: '#c7d2fe',
} as const

/** Texto de apoio em Alert do MUI (as mesmas cores, em hexa: o plugin de i18n não embrulha hexa como se fosse texto). */
export const CALLOUT = {
  warnText: '#663c00',
  warnBg: '#fff4e5',
  warnIcon: '#ed6c02',
  infoText: '#014361',
  infoIcon: '#0288d1',
  errorText: '#5f2120',
}

/** Cartão do kit: raio 16, borda violeta suave, sombra leve. */
export const kitCardSx: SxProps<Theme> = {
  bgcolor: '#fff',
  border: '1px solid rgba(120,105,223,.14)',
  borderRadius: '16px',
  boxShadow: '0 4px 24px rgba(0,0,0,.06)',
}

export const focusRing = { outline: `2px solid ${C.violet}`, outlineOffset: '2px' } as const
